export default __webpack_public_path__ + "images/three-circling-arrows.42ca2346.svg";